/**
 * @file: ISCConfigure.
 * @authors: fjxhx.
 * @createDate: 2022.
 * @Description: ISC配置
 */
import request from '@/utils/request'

/**
 * ISC-添加ISC基本配置（wzp）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function iscAdd(data) {
  return request({
    type: 'device',
    url: 'isc/add',
    method: 'post',
    data
  })
}

/**
 * ISC-获取摄像头列表（wzp）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function iscCameraList(data) {
  return request({
    type: 'device',
    url: 'isc/camera/list',
    method: 'post',
    data
  })
}

/**
 * ISC-删除ISC基本配置
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function iscDelet(data) {
  return request({
    type: 'device',
    url: 'isc/delet',
    method: 'post',
    data
  })
}

/**
 * ISC-获取ISC基本配置（wzp）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function iscGet(data) {
  return request({
    type: 'device',
    url: 'isc/get',
    method: 'post',
    data
  })
}

/**
 * ISC-获取ISC基本配置列表
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function iscListGet(data) {
  return request({
    type: 'device',
    url: 'isc/list/get',
    method: 'post',
    data
  })
}

/**
 * ISC-获取区域信息列表（wzp）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function iscRegionList(data) {
  return request({
    type: 'device',
    url: 'isc/region/list',
    method: 'post',
    data
  })
}

/**
 * ISC-修改ISC基本配置（wzp）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function iscUpdate(data) {
  return request({
    type: 'device',
    url: 'isc/update',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/ISCConfigure.js